import React from 'react'
export const PieOnlyIcon: React.FC = () => (
  <svg
    width="115"
    height="115"
    viewBox="0 0 512 512"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-2.5%"
        y="-2.6%"
        width="104.9%"
        height="103.4%"
        filterUnits="objectBoundingBox"
        id="pie_only_c"
      >
        <feGaussianBlur
          stdDeviation="5"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="10"
          dy="-10"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0.85436481 0 0 0 0 0.552928515 0 0 0 0 0.117117005 0 0 0 0.790947334 0"
          in="shadowInnerInner1"
        />
      </filter>
      <filter
        x="-3.8%"
        y="-5.3%"
        width="107.5%"
        height="110.6%"
        filterUnits="objectBoundingBox"
        id="pie_only_f"
      >
        <feGaussianBlur
          stdDeviation="13"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="-5"
          dy="-5"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0.780392157 0 0 0 0 0.501960784 0 0 0 0 0.278431373 0 0 0 0.317498907 0"
          in="shadowInnerInner1"
        />
      </filter>
      <filter
        x="-3.3%"
        y="-4.6%"
        width="106.6%"
        height="110.1%"
        filterUnits="objectBoundingBox"
        id="pie_only_i"
      >
        <feGaussianBlur
          stdDeviation="13"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 1 0 0 0 0 0.71017264 0 0 0 0 0 0 0 0 0.535183566 0"
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
        />
        <feGaussianBlur
          stdDeviation="2.5"
          in="SourceAlpha"
          result="shadowBlurInner2"
        />
        <feOffset in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.475497159 0"
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <filter
        x="-4.6%"
        y="-10%"
        width="109.2%"
        height="120%"
        filterUnits="objectBoundingBox"
        id="pie_only_l"
      >
        <feGaussianBlur
          stdDeviation="13"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="-10"
          dy="-5"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 1 0 0 0 0 0.876656309 0 0 0 0 0.562690549 0 0 0 0.748333698 0"
          in="shadowInnerInner1"
        />
      </filter>
      <filter
        x="-3%"
        y="-3%"
        width="108.9%"
        height="111.9%"
        filterUnits="objectBoundingBox"
        id="pie_only_m"
      >
        <feOffset dx="5" dy="10" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.708248415 0 0 0 0 0.406680315 0 0 0 0 0.00163296605 0 0 0 0.444192526 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <filter
        x="-21.2%"
        y="-21.1%"
        width="145.3%"
        height="148.2%"
        filterUnits="objectBoundingBox"
        id="pie_only_p"
      >
        <feGaussianBlur
          stdDeviation="10"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset dy="-20" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0.956862745 0 0 0 0 0.752941176 0 0 0 0 0.368627451 0 0 0 0.924797858 0"
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
        />
        <feGaussianBlur
          stdDeviation="5"
          in="SourceAlpha"
          result="shadowBlurInner2"
        />
        <feOffset dy="-61" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          values="0 0 0 0 0.956862745 0 0 0 0 0.752941176 0 0 0 0 0.368627451 0 0 0 0.2 0"
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <linearGradient
        x1="3.393%"
        y1="38.027%"
        x2="100%"
        y2="66.296%"
        id="pie_only_d"
      >
        <stop stopColor="#FFE3C1" offset="0%" />
        <stop stopColor="#EAC380" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="13.026%"
        y1="28.432%"
        x2="91.397%"
        y2="63.608%"
        id="pie_only_g"
      >
        <stop stopColor="#DB6C2F" offset="0%" />
        <stop stopColor="#FFB65C" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="97.929%"
        y1="60.672%"
        x2="8.71%"
        y2="48.792%"
        id="pie_only_j"
      >
        <stop stopColor="#FFB570" offset="0%" />
        <stop stopColor="#FFA94D" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="72.141%"
        y1="11.829%"
        x2="56.288%"
        y2="56.723%"
        id="pie_only_o"
      >
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F9F9EF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="55.204%"
        y1="54.452%"
        x2="92.377%"
        y2="12.891%"
        id="pie_only_q"
      >
        <stop stopColor="#FCF6E6" offset="0%" />
        <stop stopColor="#F0CA81" offset="100%" />
      </linearGradient>
      <path
        d="M17.838 315.296l360.67 97.292c12.53 3.38 25.43-4.038 28.81-16.57a23.5 23.5 0 00.81-6.12V370.16L29.5 283.617 23.514 157.13l262.135-66.847c-2.343-38.595-15.845-55.424-40.506-50.484-7.655 1.533-22.76 15.692-41.906 19.95-13.962 3.106-30.072-4.248-47.007 0-12.604 3.163-25.665 19.154-38.637 22.824-13.935 3.943-27.769-4.401-40.824 0-14.589 4.918-28.206 20.35-39.908 25.667C13.04 119.06.458 117.687.458 129v163.606a23.5 23.5 0 0017.38 22.69z"
        id="pie_only_b"
      />
      <path
        d="M410.685 130.168c0 25.41-.522 81.337-1.567 167.78a23.5 23.5 0 01-17.452 22.426l-362.03 96.412c-12.542 3.34-25.417-4.12-28.757-16.661a23.5 23.5 0 01-.786-6.584l.423-18.52 377.492-85.314 5.986-124.802-3.438-.865 26.544-39.491c2.328.916 3.585 2.512 3.585 5.62z"
        id="pie_only_e"
      />
      <path
        d="M.721 163.015l3.271 111.42a23.5 23.5 0 0017.69 22.084l368.193 93.772v-122.97L9.07 156.555a6.528 6.528 0 00-8.349 6.46z"
        id="pie_only_h"
      />
      <path
        d="M267.129 89.231c-42.73.913-80.848 5.329-114.353 13.246-33.505 7.918-84.278 26.9-152.318 56.948l389.417 109.717-122.746-179.91z"
        id="pie_only_k"
      />
      <path
        d="M93.349 0c46.925 29.721 71.67 62.089 74.236 97.103.563 3.504.757 7.085.55 10.718-2.01 35.352-41.121 62.199-87.36 59.965-45.774-2.212-81.373-32.097-80.13-66.997l-.023-1.298-.031.124c.156-1.255.257-2.51.472-3.727.776-5.765 2.547-11.274 5.175-16.433 9.1-19.04 27.94-31.852 56.52-38.434l.87-.197C101.885 32.24 111.792 18.634 93.349 0z"
        id="pie_only_n"
      />
      <radialGradient
        cx="51.378%"
        cy="50%"
        fx="51.378%"
        fy="50%"
        r="78.585%"
        gradientTransform="scale(.9361 1) rotate(-25.166 .531 .421)"
        id="pie_only_a"
      >
        <stop stopColor="#F2D4A0" offset="0%" />
        <stop stopColor="#FFCE92" offset=".889%" />
        <stop stopColor="#F4D3A0" offset="100%" />
      </radialGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="scale(-1 1) rotate(1 -2602.937 -26052.183)">
        <use fill="url(#pie_only_a)" xlinkHref="#pie_only_b" />
        <use fill="#000" filter="url(#pie_only_c)" xlinkHref="#pie_only_b" />
      </g>
      <g transform="rotate(-1 2807.23 -2642.491)">
        <use fill="url(#pie_only_d)" xlinkHref="#pie_only_e" />
        <use fill="#000" filter="url(#pie_only_f)" xlinkHref="#pie_only_e" />
      </g>
      <g transform="scale(-1 1) rotate(1 -2612.064 -25006.338)">
        <use fill="url(#pie_only_g)" xlinkHref="#pie_only_h" />
        <use fill="#000" filter="url(#pie_only_i)" xlinkHref="#pie_only_h" />
      </g>
      <g transform="scale(-1 1) rotate(1 -2612.064 -25006.338)">
        <use fill="url(#pie_only_j)" xlinkHref="#pie_only_k" />
        <use fill="#000" filter="url(#pie_only_l)" xlinkHref="#pie_only_k" />
      </g>
      <g transform="rotate(-5 761.21 -2059.705)">
        <use fill="#000" filter="url(#pie_only_m)" xlinkHref="#pie_only_n" />
        <use fill="url(#pie_only_o)" xlinkHref="#pie_only_n" />
        <use fill="#000" filter="url(#pie_only_p)" xlinkHref="#pie_only_n" />
      </g>
      <path
        d="M275.406 50.37c2.03 1.141 3.372 2.348 5.323 3.507 11.986 7.942 15.437 22.855 10.053 34.331-8.212 17.505-76.012 23.177-89.86 49.24l.303-.83c6.745-19.703 23.029-33.988 48.853-42.854l.786-.267c34.586-11.642 43.2-26.055 24.542-43.127z"
        fill="#F9F9EF"
      />
      <path
        d="M93.349 0l.505.557c16.395 18.348 6.402 31.77-28.712 40.267l-.806.197c-24.644 6.122-41.476 17.63-50.498 34.527l.098-.21C22.123 57.91 37.8 43.781 60.967 32.953 86.451 21.042 97.245 10.058 93.35 0z"
        fill="url(#pie_only_q)"
        transform="rotate(-5 761.21 -2059.705)"
      />
    </g>
  </svg>
)
